import { Component, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AppMasterService } from 'app/business/service/app/app-master.service'
import { DxDataGridComponent } from 'devextreme-angular'

@Component({
  selector: 'app-draft-cf-popup',
  templateUrl: './draft-cf-popup.component.html',
  styleUrls: ['./draft-cf-popup.component.scss'],
})
export class DraftCFPopupComponent {
  dataSource: any = []
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent
  isCheck: boolean = false
  constructor(
    public apiMasterService: AppMasterService,
    public dialogRef: MatDialogRef<DraftCFPopupComponent>,
  ) {
  }
  save() {
    this.dialogRef.close(true)
  }
  cancel() {
    this.dialogRef.close(false)
  }
}
